import useNetwork from './network';
import { IRoleModel } from './models/roleModel';

const getRoles = async (lng: string, type: number = 1) => {
    const { fetchRoles } = useNetwork();
    const result = await fetchRoles(lng);

    if (result.status === 200) {
        const dataResult = (await result.json()) as IRoleModel[];
        return dataResult
            .filter((item: IRoleModel) => item.type === type)
            .sort((a, b) => a.name.localeCompare(b.name, lng, { numeric: true }));
    }
};

export default getRoles;
